// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The app is not a zoomable web page. \`manipulation\` on the root drops the
   double-tap-to-zoom gesture (the one scaling gesture that is not a cancellable
   event) while leaving normal one-finger scrolling and taps alone; pinch is
   cancelled in JS and scaling is declined in the viewport meta tag — see
   src/zoom-lock.ts for why all three layers are required.
   \`text-size-adjust\` stops iOS inflating text on rotate, which reads as a
   zoom of its own. */
html {
  touch-action: manipulation;
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
}

body {
  margin: 0;
  touch-action: manipulation;
  font-family: var(--font-body);
  font-size: 15px;
  line-height: 1.6;
  /* The recessed page ground, NOT --background-color: that token is the
     default raised surface (tiles, cards, inputs) and in light mode now sits
     above the page. See the long note in shared/theme/theme.css. In dark mode
     the two are the same value. */
  background-color: var(--page-bg);
  color: var(--text-color);
  -webkit-font-smoothing: antialiased;
}

/* Minimal, macOS-style scrollbars everywhere: thin, rounded, and only tinted
   in while the scrollable area is hovered — instead of chunky always-on
   scrollbars on Windows/Linux. Works in light and dark mode via theme tokens.
   (Firefox uses scrollbar-width/-color; Chrome/Safari/Edge use ::-webkit-*.) */
* {
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}

*:hover,
*:focus-within {
  scrollbar-color: var(--scrollbar-thumb) transparent;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 999px;
  /* Transparent border + padding-box clip makes the visible thumb a thin
     pill with breathing room inside the 10px track. */
  border: 3px solid transparent;
  background-clip: padding-box;
}

*:hover::-webkit-scrollbar-thumb {
  background-color: var(--scrollbar-thumb);
}

::-webkit-scrollbar-thumb:hover {
  background-color: var(--scrollbar-thumb-hover);
}

::-webkit-scrollbar-corner {
  background: transparent;
}

button,
input,
select,
textarea {
  font-family: var(--font-body);
}

h1,
h2,
h3,
h4 {
  font-family: var(--font-display);
  font-weight: 600;
  letter-spacing: -0.01em;
  color: var(--text-color);
}
h1 {
  font-size: 1.5rem;
}
h2 {
  font-size: 1.15rem;
}
h3 {
  font-size: 1rem;
}
h4 {
  font-size: 0.9rem;
}

/* Page banners (Team: …, Agent: …) read as context, not headlines */
h1.text-2xl,
.text-2xl {
  font-size: 1.4rem !important;
  font-weight: 600;
  margin: 0.25rem 0 0.75rem;
}

:focus-visible {
  outline: 2px solid var(--link-color);
  outline-offset: 2px;
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation: none !important;
    transition: none !important;
  }
}

#root {
  box-sizing: border-box;
}

@media (max-width: 1064px) {
  #root {
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  html,
  body,
  #root {
    max-width: 100%;
    overflow-x: hidden;
    overflow-x: clip;
    overscroll-behavior-x: none;
  }

  #root {
    padding: 0;
  }
}

.header {
  text-align: center;
  padding: 4rem;
  padding-bottom: 1rem;
  background-color: var(--header-bg);
  color: var(--text-color);
}

.header h1 {
  color: var(--text-color);
  margin-bottom: 1rem;
  font-weight: 700;
  transition: all 0.5s ease;
}

.header p {
  color: var(--secondary-text-color);
  font-size: 1.2rem;
}

section {
  background-color: transparent;
  border-radius: var(--radius);
}

section h2 {
  color: var(--text-color);
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin: 0.5rem 0;
  font-size: 1.1rem;
  color: var(--secondary-text-color);
}

.pricing-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2rem;
}

.pricing-tier {
  padding: 1.5rem 1.5rem 2.5rem 1.5rem;
  border: 1px solid var(--border-color);
  border-radius: var(--radius);
  background-color: var(--pricing-tier-bg);
  flex: 1 1 200px;
}

.pricing-tier h3 {
  color: var(--text-color);
  margin-bottom: 1rem;
  text-align: center;
}

.pricing-tier .price {
  text-align: center;
  font-size: 1.25rem;
  font-weight: bold;
  margin: 1rem 0;
  color: var(--text-color);
}

.pricing-features {
  text-align: left;
  padding-left: 1rem;
}

.pricing-features p {
  color: var(--secondary-text-color);
  margin: 0.5rem 0;
}

footer {
  text-align: left;
  padding: 1rem 15px;
  margin-top: 3rem;
  margin-bottom: 2rem;
  color: var(--footer-text-color);
  font-size: 0.8rem;
}

button {
  background-color: var(--button-primary-bg);
  color: var(--button-primary-text);
  border: none;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0.01em;
  border-radius: 999px;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.3s;
}

button:not(:disabled):hover {
  background-color: var(--button-primary-hover);
}

/* The canonical list-item / tile treatment, matching .board-card: the raised
   surface plus an outline, so a row of them reads the same whether it is a
   project board, a provider list or a roles list. Most *-card classes
   (role-card, billing-metric-card, model-provider-card, …) are layout-only
   modifiers on top of this, so they inherit it. Containers that merely GROUP
   tiles should use --card-background instead and stay a level down. */
.card {
  background-color: var(--surface-raised);
  border: 1px solid var(--border-color);
  padding: 0.25em 1em 0.25em 1em;
  border-radius: var(--radius);
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease;
}

.card:hover {
  background-color: var(--card-hover);
}

/* A clickable tile is often a <button> (list rows on the Work page, the card
   modal's pending-work feed, action logs). A bare \`.card:hover\` is (0,2,0) and
   loses to the global \`button:not(:disabled):hover\` above, so those tiles took
   the primary-button fill instead of the tile hover — unreadable in dark mode,
   where --button-primary-hover is a LIGHT blue behind the tile's inherited
   light text. Qualifying by element wins outright, so .card stays canonical
   whatever tag it lands on and callers stop hand-rolling specificity. */
button.card:not(:disabled):hover,
button.card:not(:disabled):active {
  background-color: var(--card-hover);
}

/* A touch device leaves :hover applied after the finger lifts, so pressing a
   tile and scrolling away left it stuck in the hover fill. Where there is no
   real pointer, hover paints the tile's resting surface and :active carries
   the press feedback, which the browser does clear on lift. */
@media (hover: none) {
  .card:hover,
  button.card:not(:disabled):hover {
    background-color: var(--surface-raised);
  }

  button.card:not(:disabled):active {
    background-color: var(--card-hover);
  }
}

form > div {
  margin-bottom: 1rem;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.9rem;
  color: var(--text-color);
}

input,
textarea,
select {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid var(--input-border);
  border-radius: var(--radius-sm);
  font-size: 16px; /* Ensure consistent font size across browsers */
  background-color: var(--background-color);
  color: var(--text-color);
  box-sizing: border-box;
}

input[type='checkbox'],
input[type='radio'] {
  width: auto;
}

input[type='number'] {
  color-scheme: light;
}

[data-theme='dark'] input[type='number'] {
  color-scheme: dark;
}

input:focus,
textarea:focus,
select:focus {
  border-color: var(--link-color);
  outline: none;
  box-shadow: 0 0 0 3px var(--accent-tint);
}

form button {
  width: 100%;
  margin-top: 1rem;
}

p {
  margin-top: 1rem;
}

p a {
  color: var(--link-color);
  text-decoration: none;
}

.static-title {
  position: relative;
  display: inline-block;
  white-space: nowrap;
  font-size: clamp(1.5rem, 4vw, 2.5rem);
}

/* Increase font size for mobile devices to match iPad size */
@media (max-width: 768px) {
  .static-title {
    font-size: clamp(2rem, 4vw, 2.5rem);
  }
}

.rainbow-o {
  color: #7fa8cd;
}
.rainbow-r {
  color: #6f9dc6;
}
.rainbow-e {
  color: #5f92bf;
}
.rainbow-p {
  color: #4f86b6;
}
.rainbow-l {
  color: #3f77a5;
}
.rainbow-y {
  color: #29618e;
}

.home-page-title {
  text-align: left;
  padding-right: 20%;
  padding-left: 19.5%;
  overflow: visible;
  white-space: nowrap;
  margin-bottom: 3rem;
}

/* Responsive padding adjustments */
@media (max-width: 1200px) {
  .home-page-title {
    padding-left: 13%;
  }
}

@media (max-width: 992px) {
  .home-page-title {
    padding-left: 6.5%;
  }
}

@media (max-width: 768px) {
  .home-page-title {
    padding-left: 0;
    padding-right: 0;
    text-align: left;
    max-width: 900px;
    margin-left: auto;
    margin-right: auto;
    overflow-x: visible;
  }

  .home-page-title h1 {
    white-space: nowrap;
    overflow: visible;
  }

  .home-page-title p {
    white-space: normal;
    overflow-wrap: break-word;
    word-wrap: break-word;
  }
}

@media (max-width: 576px) {
  .home-page-title {
    padding-left: 0;
    padding-right: 0;
  }
}

.home-page-buttons {
  margin-top: 2rem;
  display: flex;
  gap: 1rem;
  justify-content: flex-start;
}

@media (max-width: 768px) {
  .home-page-buttons {
    justify-content: flex-start;
  }
}

.home-page-buttons a {
  display: inline-block;
}

/* Adjust the subtitle in the home-page-title div */
.home-page-title p {
  font-size: 1.2rem; /* Set an appropriate font size */
  text-align: left;
  text-wrap: auto;
  max-width: 50em;
}

@media (max-width: 768px) {
  .home-page-title p {
    text-align: left;
  }
}
.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.form-group input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--input-border);
  border-radius: var(--radius-sm);
  box-sizing: border-box;
}

.form-group small {
  display: block;
  margin-top: 0.25rem;
  color: var(--secondary-text-color);
  font-size: 0.8rem;
}

.error-message {
  color: var(--danger-text);
  font-weight: 500;
  margin: 0.5rem 0;
  text-align: left;
}

/* A form-level refusal that needs to survive being read at a glance —
   "you are at your team limit", not a per-field validation note. Boxed
   rather than bare text so it reads as a blocker; \`.error-message\` above
   stays the inline, per-field treatment. */
.form-error-banner {
  margin: 0 0 1.5rem;
  padding: 0.75rem 1rem;
  border: 1px solid var(--danger-border);
  border-radius: var(--radius-sm);
  background-color: var(--danger-bg);
  color: var(--danger-text);
  font-weight: 500;
  text-align: left;
}

.success-message {
  color: var(--success-text);
  font-weight: 500;
  margin: 0.5rem 0;
  text-align: left;
}

.account-deletion-section {
  margin-top: 2.75rem;
  padding-top: 1.25rem;
  border-top: 1px solid var(--border-color);
}

.account-deletion-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
}

.account-deletion-summary h3,
.account-deletion-summary p {
  margin: 0;
}

.account-deletion-summary p {
  margin-top: 0.25rem;
  color: var(--secondary-text-color);
  line-height: 1.45;
}

.account-deletion-review-button,
.account-deletion-submit-button {
  border-color: var(--danger-border);
  color: var(--danger-text);
}

.account-deletion-review-button {
  flex: 0 0 auto;
  padding: 0.55rem 0.9rem;
  border: 1px solid var(--danger-border);
  border-radius: 999px;
  background: transparent;
  font: inherit;
  cursor: pointer;
}

.account-deletion-review-button:hover {
  border-color: var(--danger-text);
}

.account-deletion-review-button:focus-visible,
.account-deletion-submit-button:focus-visible,
.account-deletion-phrase:focus-visible,
.account-deletion-successor-select:focus-visible {
  outline: 2px solid var(--danger-text);
  outline-offset: 3px;
}

.account-deletion-confirmation {
  margin-top: 1.25rem;
  padding: 0.25rem 0 0.25rem 1rem;
  border-left: 2px solid var(--danger-border);
}

.account-deletion-facts {
  margin: 0 0 1.5rem;
}

.account-deletion-facts > div {
  padding: 0.8rem 0;
  border-bottom: 1px solid var(--border-color);
}

.account-deletion-facts dt {
  font-family: var(--font-display);
  font-weight: 650;
}

.account-deletion-facts dd {
  margin: 0.25rem 0 0;
  color: var(--secondary-text-color);
  line-height: 1.55;
}

.account-deletion-confirmation form {
  max-width: 100%;
}

.account-deletion-confirmation label {
  display: block;
  margin-bottom: 0.5rem;
}

.account-deletion-confirmation label strong,
.account-deletion-phrase {
  font-family: var(--font-mono);
}

.account-deletion-handoffs {
  margin: 0 0 1.5rem;
}

.account-deletion-handoffs h4,
.account-deletion-handoffs-intro {
  margin: 0;
}

.account-deletion-handoffs h4 {
  font-family: var(--font-display);
}

.account-deletion-handoffs-intro,
.account-deletion-candidate-status,
.account-deletion-handoff-heading p,
.account-deletion-handoff-ownership {
  color: var(--secondary-text-color);
  line-height: 1.5;
}

.account-deletion-handoffs-intro {
  margin-top: 0.35rem;
}

.account-deletion-handoff-ledger {
  margin-top: 1rem;
  border-top: 1px solid var(--border-color);
}

.account-deletion-handoff-row {
  padding: 1rem 0;
  border-bottom: 1px solid var(--border-color);
}

.account-deletion-handoff-heading {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 1rem;
}

.account-deletion-handoff-heading h5,
.account-deletion-handoff-heading p,
.account-deletion-handoff-ownership {
  margin: 0;
}

.account-deletion-handoff-heading h5 {
  font-family: var(--font-display);
  font-size: 1rem;
}

.account-deletion-handoff-heading p {
  font-family: var(--font-mono);
  font-size: 0.78rem;
}

.account-deletion-handoff-ownership {
  margin-top: 0.25rem;
  font-size: 0.9rem;
}

.account-deletion-handoff-row label {
  margin: 0.8rem 0 0.35rem;
  font-weight: 600;
}

.account-deletion-successor-select {
  box-sizing: border-box;
  width: 100%;
  padding: 0.72rem 0.8rem;
  border: 1px solid var(--input-border);
  border-radius: var(--radius-sm);
  background: var(--background-color);
  color: var(--text-color);
  font: inherit;
}

.account-deletion-candidate-status {
  margin: 0 0 1.5rem;
}

.account-deletion-candidate-error,
.account-deletion-candidate-blocker {
  color: var(--danger-text);
  line-height: 1.5;
}

.account-deletion-candidate-error {
  margin: 0 0 1.5rem;
}

.account-deletion-candidate-blocker {
  margin: 0.5rem 0 0;
  font-size: 0.9rem;
}

.account-deletion-phrase-control {
  max-width: 21rem;
}

.account-deletion-phrase {
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 0.75rem;
  padding: 0.72rem 0.8rem;
  border: 1px solid var(--input-border);
  border-radius: var(--radius-sm);
  background: var(--background-color);
  color: var(--text-color);
  letter-spacing: 0.04em;
}

.account-deletion-submit-button:not(:disabled) {
  border-color: var(--danger-button-bg);
  background: var(--danger-button-bg);
  color: var(--danger-button-text);
}

.account-deletion-submit-button:not(:disabled):hover {
  border-color: var(--danger-button-hover);
  background: var(--danger-button-hover);
}

.account-deletion-request-error,
.account-deletion-status-error {
  color: var(--danger-text);
  line-height: 1.5;
}

.account-deletion-receipt {
  margin-top: clamp(2rem, 9vh, 5rem);
  padding: 1.5rem;
  border: 1px solid var(--border-color);
  border-radius: var(--radius);
  background: var(--surface-raised);
}

.account-deletion-eyebrow {
  margin: 0 0 0.5rem;
  color: var(--secondary-text-color);
  font-family: var(--font-mono);
  font-size: 0.73rem;
  letter-spacing: 0.09em;
  text-transform: uppercase;
}

.account-deletion-receipt h2 {
  margin: 0;
  font-family: var(--font-display);
}

.account-deletion-receipt-copy,
.account-deletion-receipt-note {
  color: var(--secondary-text-color);
  line-height: 1.55;
}

.account-deletion-progress {
  margin: 1.75rem 0;
  padding: 1rem 0;
  border-top: 1px solid var(--border-color);
  border-bottom: 1px solid var(--border-color);
}

.account-deletion-progress-track {
  height: 0.5rem;
  overflow: hidden;
  border-radius: 999px;
  background: var(--surface-2);
}

.account-deletion-progress-track span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: var(--link-color);
}

.account-deletion-progress--completed .account-deletion-progress-track span {
  background: var(--success-text);
}

.account-deletion-progress p {
  margin: 0.75rem 0 0;
  color: var(--secondary-text-color);
}

.account-deletion-progress strong {
  color: var(--text-color);
  font-family: var(--font-mono);
  font-size: 1.4rem;
}

@media (max-width: 560px) {
  .account-deletion-summary {
    align-items: flex-start;
    flex-direction: column;
    gap: 0.85rem;
  }

  .account-deletion-confirmation {
    padding-left: 0.75rem;
  }

  .account-deletion-confirmation form {
    max-width: none;
  }

  .account-deletion-handoff-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 0.15rem;
  }

  .account-deletion-receipt {
    padding: 1.1rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .account-deletion-review-button,
  .account-deletion-submit-button,
  .account-deletion-progress-track span {
    transition: none;
  }
}

/* Button styles */
.lightButton {
  background-color: var(--button-light-bg);
  color: var(--text-color);
  padding: 0.5rem 1rem;
  font-size: 1rem;
  border: 1px solid var(--button-light-border);
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.lightButton:not(:disabled):hover {
  background-color: var(--accent-tint);
  border-color: var(--link-color);
  color: var(--accent-tint-text) !important;
}

/* Only the hover was guarded against :disabled, so a disabled light button
   kept full contrast and a pointer cursor and read as perfectly clickable.
   Opacity follows \`.delete-button:disabled\`, the existing convention. */
.lightButton:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* Secondary action: quiet outline pill (referenced across modals; was
   previously undefined and fell back to the primary button style) */
.secondaryButton {
  background-color: transparent;
  color: var(--text-color);
  border: 1px solid var(--button-light-border);
  border-radius: 999px;
}

.secondaryButton:not(:disabled):hover {
  background-color: var(--accent-tint);
  border-color: var(--link-color);
  color: var(--accent-tint-text);
}

/* Description text style */
.descriptionText {
  color: var(--secondary-text-color);
  margin-bottom: 1rem;
  font-size: 1rem;
  line-height: 1.5;
}

/* Breadcrumb styles */
.breadcrumb {
  margin-bottom: 1.5rem;
  padding: 0.5rem 0;
}

.breadcrumb ol {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding: 0;
}

.breadcrumb li {
  display: flex;
  align-items: center;
  margin: 0;
  font-size: 0.78rem;
  letter-spacing: 0.02em;
  color: var(--secondary-text-color);
}

.breadcrumb li a {
  color: var(--secondary-text-color);
  text-decoration: none;
  transition: color 0.2s ease;
}

.breadcrumb li a:hover {
  color: var(--link-color);
  text-decoration: none;
}

.breadcrumb li.active {
  color: var(--secondary-text-color);
}

.breadcrumb .separator {
  margin: 0 0.5rem;
  color: var(--border-strong);
}

/* Every modal surface (shared Modal plus the bare overlays that bypass it):
   \`manipulation\` kills double-tap zoom while keeping normal touch scrolling,
   and \`contain\` stops a scroll that hits the modal's edge from chaining into
   the page behind it. Pinch-zoom is cancelled in JS while a body scroll lock
   is held — see useBodyScrollLock. */
.delete-modal-overlay,
.knowledge-search-modal-overlay,
.tools-modal-overlay,
.wiki-create-overlay,
.audio-settings-overlay,
.email-overlay,
.interaction-modal-backdrop,
.chat-dock-backdrop,
.knowledge-graph-container.fullscreen {
  touch-action: manipulation;
  overscroll-behavior: contain;
}

/* Delete Modal Styles */
.delete-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3000;
}

.delete-modal-container {
  --modal-pad: 20px;
  background-color: rgba(var(--modal-bg-rgb, 255, 255, 255), 0.92);
  color: var(--text-color);
  padding: var(--modal-pad);
  border-radius: var(--radius);
  max-width: 400px;
  width: 100%;
  box-shadow:
    var(--card-shadow),
    0 0 15px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(var(--border-color-rgb, 209, 213, 219), 0.5);
  backdrop-filter: blur(10px);
}

/* Initial programmatic focus belongs to the dialog surface. The surface is
   already visually unmistakable; suppress the global focus ring here so it
   does not appear as a stray outline around the header's close control. */
.delete-modal-container:focus {
  outline: none;
}

/* Content-heavy modals (e.g. the project card detail) become an app surface
   on phones: full-screen, no floating card, matching the mobile chat dock.
   !important overrides the inline maxWidth/maxHeight the Modal sets. */
@media (max-width: 768px) {
  .delete-modal-container.modal-fullscreen-mobile {
    box-sizing: border-box;
    width: 100vw;
    width: 100dvw;
    height: 100vh;
    height: 100dvh;
    max-width: none !important;
    max-height: 100dvh !important;
    border: 0;
    border-radius: 0;
    box-shadow: none;
    padding-top: calc(var(--modal-pad) + env(safe-area-inset-top));
    padding-bottom: calc(var(--modal-pad) + env(safe-area-inset-bottom));
    /* Column layout: the header holds its height, the body fills the rest
       and scrolls inside itself. Without this the modal is 100dvh but the
       content flows at its natural height, leaving empty space (and a
       mid-screen composer) below a short card. */
    display: flex;
    flex-direction: column;
    overflow: hidden !important;
  }

  /* Header (title + close row) keeps its natural height */
  .delete-modal-container.modal-fullscreen-mobile > :first-child {
    flex: 0 0 auto;
  }

  /* The card body grows to fill and scrolls internally. Its desktop
     max-height (72vh) would otherwise cap it short of the screen, leaving
     empty space and a mid-screen composer. */
  .delete-modal-container.modal-fullscreen-mobile > .card-detail {
    flex: 1 1 auto;
    min-height: 0;
    max-height: none;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }

  /* Pin the composer to the bottom of the screen when the card is short;
     it still scrolls with (and sticks over) a long card's content */
  .modal-fullscreen-mobile .card-detail-footer {
    margin-top: auto;
  }
}

.delete-modal-actions {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 20px;
}

.delete-button {
  background-color: var(--button-light-bg);
  color: var(--danger-text);
  border: 1px solid var(--danger-text);
  transition: all 0.2s ease;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.delete-button:not(:disabled):hover {
  background-color: var(--danger-text);
  color: var(--background-color);
  box-shadow: none;
}

.delete-button:active {
  opacity: 0.85;
}

.delete-button:disabled {
  opacity: 0.7;
}

.member-removal-handoff {
  display: grid;
  gap: 0.75rem;
}

.member-removal-handoff p {
  margin: 0;
  color: var(--text-color);
}

.member-removal-handoff .error-message {
  color: var(--danger-text);
}

.member-removal-handoff label {
  display: grid;
  gap: 0.4rem;
  color: var(--text-color);
  font-weight: 600;
}

.member-removal-handoff select {
  width: 100%;
  color: var(--text-color);
  background: var(--input-bg);
  border: 1px solid var(--input-border);
  border-radius: var(--radius);
  padding: 0.6rem 0.7rem;
}

.member-removal-handoff-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 0.5rem;
}

/* Add and Edit Icon Button Styles */
.icon-button {
  display: inline-flex;
  align-items: center;
  background: none;
  border: none;
  color: var(--link-color);
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 999px;
  transition: all 0.2s ease;
}

.icon-button:not(:disabled):hover {
  background-color: var(--accent-tint);
  /* Pair the accent-tint hover background with its intended text color so the
     label stays high-contrast in light and dark mode. */
  color: var(--accent-tint-text);
}

.icon-button:active {
  background-color: var(--card-hover);
}

.icon-button svg {
  margin-right: 0.25rem;
}

/* Info message with warning icon */
.info-message {
  font-size: 0.85rem;
  padding: 8px 12px;
  margin-top: 8px;
  border: 1px solid var(--warning-border);
  border-radius: var(--radius-sm);
  background-color: var(--warning-bg);
  color: var(--text-color);
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.info-message::before {
  content: '⚠️';
  font-size: 1rem;
  display: inline-block;
}

/* Mermaid diagrams (\`\`\`mermaid fences hydrated client-side) */
.mermaid-diagram {
  margin: 0.75em 0;
  overflow-x: auto;
  text-align: center;
}

.mermaid-diagram svg {
  max-width: 100%;
  height: auto;
}

.mermaid-error {
  margin: 0.75em 0;
  padding: 8px 10px;
  border: 1px solid var(--error-color, #d24c4c);
  border-radius: var(--radius-sm, 6px);
  font-size: 0.85em;
}

.mermaid-error-message {
  color: var(--error-color, #d24c4c);
  margin-bottom: 6px;
}

.mermaid-error pre {
  margin: 0;
  overflow-x: auto;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;;;;qBAMqB;AACrB;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB;;;kCAGgC;EAChC,gCAAgC;EAChC,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;;;+EAG+E;AAC/E;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;;EAEE,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB;sDACoD;EACpD,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;;;EAIE,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;;AAEA,oEAAoE;AACpE;;EAEE,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE;;;IAGE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;;IAGE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,4BAA4B;EAC5B,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,iCAAiC;EACjC,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;;;;;sEAKsE;AACtE;EACE,uCAAuC;EACvC,qCAAqC;EACrC,8BAA8B;EAC9B,4BAA4B;EAC5B,eAAe;EACf;;0BAEwB;AAC1B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;;;;;wEAMwE;AACxE;;EAEE,mCAAmC;AACrC;;AAEA;;;8DAG8D;AAC9D;EACE;;IAEE,uCAAuC;EACzC;;EAEA;IACE,mCAAmC;EACrC;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;;;EAGE,WAAW;EACX,eAAe;EACf,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe,EAAE,gDAAgD;EACjE,yCAAyC;EACzC,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,+BAA+B;EAC/B,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA,6DAA6D;AAC7D;EACE;IACE,mCAAmC;EACrC;AACF;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA,mDAAmD;AACnD;EACE,iBAAiB,EAAE,iCAAiC;EACpD,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;2CAG2C;AAC3C;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sCAAsC;EACtC,+BAA+B;EAC/B,kCAAkC;EAClC,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;;EAEE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,sCAAsC;EACtC,oBAAoB;EACpB,uBAAuB;EACvB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;;EAIE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;;EAIE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;;EAGE,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,qCAAqC;EACrC,+BAA+B;EAC/B,mCAAmC;EACnC,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,qCAAqC;EACrC,+BAA+B;EAC/B,mCAAmC;EACnC,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,qCAAqC;EACrC,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,gCAAgC;AAClC;;AAEA;;EAEE,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;;IAGE,gBAAgB;EAClB;AACF;;AAEA,kBAAkB;AAClB;EACE,wCAAwC;EACxC,wBAAwB;EACxB,oBAAoB;EACpB,eAAe;EACf,4CAA4C;EAC5C,oBAAoB;EACpB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;;wEAEwE;AACxE;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;oEACoE;AACpE;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;;;qCAIqC;AACrC;;;;;;;;;EASE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gEAAgE;EAChE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;EAChB,WAAW;EACX;;+BAE6B;EAC7B,mEAAmE;EACnE,2BAA2B;AAC7B;;AAEA;;0EAE0E;AAC1E;EACE,aAAa;AACf;;AAEA;;uEAEuE;AACvE;EACE;IACE,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,cAAc;IACd,0BAA0B;IAC1B,6BAA6B;IAC7B,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,8DAA8D;IAC9D,oEAAoE;IACpE;;;iDAG6C;IAC7C,aAAa;IACb,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA,wDAAwD;EACxD;IACE,cAAc;EAChB;;EAEA;;6CAE2C;EAC3C;IACE,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;oEACkE;EAClE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,2BAA2B;EAC3B,qCAAqC;EACrC,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC;wDACsD;EACtD,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,uCAAuC;EACvC,+BAA+B;EAC/B,mCAAmC;EACnC,wBAAwB;EACxB,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;AACvB;;AAEA,8DAA8D;AAC9D;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6CAA6C;EAC7C,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB","sourcesContent":["/* The app is not a zoomable web page. `manipulation` on the root drops the\n   double-tap-to-zoom gesture (the one scaling gesture that is not a cancellable\n   event) while leaving normal one-finger scrolling and taps alone; pinch is\n   cancelled in JS and scaling is declined in the viewport meta tag — see\n   src/zoom-lock.ts for why all three layers are required.\n   `text-size-adjust` stops iOS inflating text on rotate, which reads as a\n   zoom of its own. */\nhtml {\n  touch-action: manipulation;\n  -webkit-text-size-adjust: 100%;\n  text-size-adjust: 100%;\n}\n\nbody {\n  margin: 0;\n  touch-action: manipulation;\n  font-family: var(--font-body);\n  font-size: 15px;\n  line-height: 1.6;\n  /* The recessed page ground, NOT --background-color: that token is the\n     default raised surface (tiles, cards, inputs) and in light mode now sits\n     above the page. See the long note in shared/theme/theme.css. In dark mode\n     the two are the same value. */\n  background-color: var(--page-bg);\n  color: var(--text-color);\n  -webkit-font-smoothing: antialiased;\n}\n\n/* Minimal, macOS-style scrollbars everywhere: thin, rounded, and only tinted\n   in while the scrollable area is hovered — instead of chunky always-on\n   scrollbars on Windows/Linux. Works in light and dark mode via theme tokens.\n   (Firefox uses scrollbar-width/-color; Chrome/Safari/Edge use ::-webkit-*.) */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: transparent transparent;\n}\n\n*:hover,\n*:focus-within {\n  scrollbar-color: var(--scrollbar-thumb) transparent;\n}\n\n::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: transparent;\n  border-radius: 999px;\n  /* Transparent border + padding-box clip makes the visible thumb a thin\n     pill with breathing room inside the 10px track. */\n  border: 3px solid transparent;\n  background-clip: padding-box;\n}\n\n*:hover::-webkit-scrollbar-thumb {\n  background-color: var(--scrollbar-thumb);\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background-color: var(--scrollbar-thumb-hover);\n}\n\n::-webkit-scrollbar-corner {\n  background: transparent;\n}\n\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: var(--font-body);\n}\n\nh1,\nh2,\nh3,\nh4 {\n  font-family: var(--font-display);\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  color: var(--text-color);\n}\nh1 {\n  font-size: 1.5rem;\n}\nh2 {\n  font-size: 1.15rem;\n}\nh3 {\n  font-size: 1rem;\n}\nh4 {\n  font-size: 0.9rem;\n}\n\n/* Page banners (Team: …, Agent: …) read as context, not headlines */\nh1.text-2xl,\n.text-2xl {\n  font-size: 1.4rem !important;\n  font-weight: 600;\n  margin: 0.25rem 0 0.75rem;\n}\n\n:focus-visible {\n  outline: 2px solid var(--link-color);\n  outline-offset: 2px;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation: none !important;\n    transition: none !important;\n  }\n}\n\n#root {\n  box-sizing: border-box;\n}\n\n@media (max-width: 1064px) {\n  #root {\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  html,\n  body,\n  #root {\n    max-width: 100%;\n    overflow-x: hidden;\n    overflow-x: clip;\n    overscroll-behavior-x: none;\n  }\n\n  #root {\n    padding: 0;\n  }\n}\n\n.header {\n  text-align: center;\n  padding: 4rem;\n  padding-bottom: 1rem;\n  background-color: var(--header-bg);\n  color: var(--text-color);\n}\n\n.header h1 {\n  color: var(--text-color);\n  margin-bottom: 1rem;\n  font-weight: 700;\n  transition: all 0.5s ease;\n}\n\n.header p {\n  color: var(--secondary-text-color);\n  font-size: 1.2rem;\n}\n\nsection {\n  background-color: transparent;\n  border-radius: var(--radius);\n}\n\nsection h2 {\n  color: var(--text-color);\n}\n\nul {\n  list-style-type: none;\n  padding: 0;\n}\n\nli {\n  margin: 0.5rem 0;\n  font-size: 1.1rem;\n  color: var(--secondary-text-color);\n}\n\n.pricing-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 2rem;\n}\n\n.pricing-tier {\n  padding: 1.5rem 1.5rem 2.5rem 1.5rem;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius);\n  background-color: var(--pricing-tier-bg);\n  flex: 1 1 200px;\n}\n\n.pricing-tier h3 {\n  color: var(--text-color);\n  margin-bottom: 1rem;\n  text-align: center;\n}\n\n.pricing-tier .price {\n  text-align: center;\n  font-size: 1.25rem;\n  font-weight: bold;\n  margin: 1rem 0;\n  color: var(--text-color);\n}\n\n.pricing-features {\n  text-align: left;\n  padding-left: 1rem;\n}\n\n.pricing-features p {\n  color: var(--secondary-text-color);\n  margin: 0.5rem 0;\n}\n\nfooter {\n  text-align: left;\n  padding: 1rem 15px;\n  margin-top: 3rem;\n  margin-bottom: 2rem;\n  color: var(--footer-text-color);\n  font-size: 0.8rem;\n}\n\nbutton {\n  background-color: var(--button-primary-bg);\n  color: var(--button-primary-text);\n  border: none;\n  padding: 0.5rem 1rem;\n  font-size: 1rem;\n  font-weight: 500;\n  letter-spacing: 0.01em;\n  border-radius: 999px;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\nbutton:not(:disabled):hover {\n  background-color: var(--button-primary-hover);\n}\n\n/* The canonical list-item / tile treatment, matching .board-card: the raised\n   surface plus an outline, so a row of them reads the same whether it is a\n   project board, a provider list or a roles list. Most *-card classes\n   (role-card, billing-metric-card, model-provider-card, …) are layout-only\n   modifiers on top of this, so they inherit it. Containers that merely GROUP\n   tiles should use --card-background instead and stay a level down. */\n.card {\n  background-color: var(--surface-raised);\n  border: 1px solid var(--border-color);\n  padding: 0.25em 1em 0.25em 1em;\n  border-radius: var(--radius);\n  cursor: pointer;\n  transition:\n    background-color 0.2s ease,\n    border-color 0.2s ease;\n}\n\n.card:hover {\n  background-color: var(--card-hover);\n}\n\n/* A clickable tile is often a <button> (list rows on the Work page, the card\n   modal's pending-work feed, action logs). A bare `.card:hover` is (0,2,0) and\n   loses to the global `button:not(:disabled):hover` above, so those tiles took\n   the primary-button fill instead of the tile hover — unreadable in dark mode,\n   where --button-primary-hover is a LIGHT blue behind the tile's inherited\n   light text. Qualifying by element wins outright, so .card stays canonical\n   whatever tag it lands on and callers stop hand-rolling specificity. */\nbutton.card:not(:disabled):hover,\nbutton.card:not(:disabled):active {\n  background-color: var(--card-hover);\n}\n\n/* A touch device leaves :hover applied after the finger lifts, so pressing a\n   tile and scrolling away left it stuck in the hover fill. Where there is no\n   real pointer, hover paints the tile's resting surface and :active carries\n   the press feedback, which the browser does clear on lift. */\n@media (hover: none) {\n  .card:hover,\n  button.card:not(:disabled):hover {\n    background-color: var(--surface-raised);\n  }\n\n  button.card:not(:disabled):active {\n    background-color: var(--card-hover);\n  }\n}\n\nform > div {\n  margin-bottom: 1rem;\n}\n\nlabel {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  font-size: 0.9rem;\n  color: var(--text-color);\n}\n\ninput,\ntextarea,\nselect {\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid var(--input-border);\n  border-radius: var(--radius-sm);\n  font-size: 16px; /* Ensure consistent font size across browsers */\n  background-color: var(--background-color);\n  color: var(--text-color);\n  box-sizing: border-box;\n}\n\ninput[type='checkbox'],\ninput[type='radio'] {\n  width: auto;\n}\n\ninput[type='number'] {\n  color-scheme: light;\n}\n\n[data-theme='dark'] input[type='number'] {\n  color-scheme: dark;\n}\n\ninput:focus,\ntextarea:focus,\nselect:focus {\n  border-color: var(--link-color);\n  outline: none;\n  box-shadow: 0 0 0 3px var(--accent-tint);\n}\n\nform button {\n  width: 100%;\n  margin-top: 1rem;\n}\n\np {\n  margin-top: 1rem;\n}\n\np a {\n  color: var(--link-color);\n  text-decoration: none;\n}\n\n.static-title {\n  position: relative;\n  display: inline-block;\n  white-space: nowrap;\n  font-size: clamp(1.5rem, 4vw, 2.5rem);\n}\n\n/* Increase font size for mobile devices to match iPad size */\n@media (max-width: 768px) {\n  .static-title {\n    font-size: clamp(2rem, 4vw, 2.5rem);\n  }\n}\n\n.rainbow-o {\n  color: #7fa8cd;\n}\n.rainbow-r {\n  color: #6f9dc6;\n}\n.rainbow-e {\n  color: #5f92bf;\n}\n.rainbow-p {\n  color: #4f86b6;\n}\n.rainbow-l {\n  color: #3f77a5;\n}\n.rainbow-y {\n  color: #29618e;\n}\n\n.home-page-title {\n  text-align: left;\n  padding-right: 20%;\n  padding-left: 19.5%;\n  overflow: visible;\n  white-space: nowrap;\n  margin-bottom: 3rem;\n}\n\n/* Responsive padding adjustments */\n@media (max-width: 1200px) {\n  .home-page-title {\n    padding-left: 13%;\n  }\n}\n\n@media (max-width: 992px) {\n  .home-page-title {\n    padding-left: 6.5%;\n  }\n}\n\n@media (max-width: 768px) {\n  .home-page-title {\n    padding-left: 0;\n    padding-right: 0;\n    text-align: left;\n    max-width: 900px;\n    margin-left: auto;\n    margin-right: auto;\n    overflow-x: visible;\n  }\n\n  .home-page-title h1 {\n    white-space: nowrap;\n    overflow: visible;\n  }\n\n  .home-page-title p {\n    white-space: normal;\n    overflow-wrap: break-word;\n    word-wrap: break-word;\n  }\n}\n\n@media (max-width: 576px) {\n  .home-page-title {\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n\n.home-page-buttons {\n  margin-top: 2rem;\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-start;\n}\n\n@media (max-width: 768px) {\n  .home-page-buttons {\n    justify-content: flex-start;\n  }\n}\n\n.home-page-buttons a {\n  display: inline-block;\n}\n\n/* Adjust the subtitle in the home-page-title div */\n.home-page-title p {\n  font-size: 1.2rem; /* Set an appropriate font size */\n  text-align: left;\n  text-wrap: auto;\n  max-width: 50em;\n}\n\n@media (max-width: 768px) {\n  .home-page-title p {\n    text-align: left;\n  }\n}\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid var(--input-border);\n  border-radius: var(--radius-sm);\n  box-sizing: border-box;\n}\n\n.form-group small {\n  display: block;\n  margin-top: 0.25rem;\n  color: var(--secondary-text-color);\n  font-size: 0.8rem;\n}\n\n.error-message {\n  color: var(--danger-text);\n  font-weight: 500;\n  margin: 0.5rem 0;\n  text-align: left;\n}\n\n/* A form-level refusal that needs to survive being read at a glance —\n   \"you are at your team limit\", not a per-field validation note. Boxed\n   rather than bare text so it reads as a blocker; `.error-message` above\n   stays the inline, per-field treatment. */\n.form-error-banner {\n  margin: 0 0 1.5rem;\n  padding: 0.75rem 1rem;\n  border: 1px solid var(--danger-border);\n  border-radius: var(--radius-sm);\n  background-color: var(--danger-bg);\n  color: var(--danger-text);\n  font-weight: 500;\n  text-align: left;\n}\n\n.success-message {\n  color: var(--success-text);\n  font-weight: 500;\n  margin: 0.5rem 0;\n  text-align: left;\n}\n\n.account-deletion-section {\n  margin-top: 2.75rem;\n  padding-top: 1.25rem;\n  border-top: 1px solid var(--border-color);\n}\n\n.account-deletion-summary {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.5rem;\n}\n\n.account-deletion-summary h3,\n.account-deletion-summary p {\n  margin: 0;\n}\n\n.account-deletion-summary p {\n  margin-top: 0.25rem;\n  color: var(--secondary-text-color);\n  line-height: 1.45;\n}\n\n.account-deletion-review-button,\n.account-deletion-submit-button {\n  border-color: var(--danger-border);\n  color: var(--danger-text);\n}\n\n.account-deletion-review-button {\n  flex: 0 0 auto;\n  padding: 0.55rem 0.9rem;\n  border: 1px solid var(--danger-border);\n  border-radius: 999px;\n  background: transparent;\n  font: inherit;\n  cursor: pointer;\n}\n\n.account-deletion-review-button:hover {\n  border-color: var(--danger-text);\n}\n\n.account-deletion-review-button:focus-visible,\n.account-deletion-submit-button:focus-visible,\n.account-deletion-phrase:focus-visible,\n.account-deletion-successor-select:focus-visible {\n  outline: 2px solid var(--danger-text);\n  outline-offset: 3px;\n}\n\n.account-deletion-confirmation {\n  margin-top: 1.25rem;\n  padding: 0.25rem 0 0.25rem 1rem;\n  border-left: 2px solid var(--danger-border);\n}\n\n.account-deletion-facts {\n  margin: 0 0 1.5rem;\n}\n\n.account-deletion-facts > div {\n  padding: 0.8rem 0;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.account-deletion-facts dt {\n  font-family: var(--font-display);\n  font-weight: 650;\n}\n\n.account-deletion-facts dd {\n  margin: 0.25rem 0 0;\n  color: var(--secondary-text-color);\n  line-height: 1.55;\n}\n\n.account-deletion-confirmation form {\n  max-width: 100%;\n}\n\n.account-deletion-confirmation label {\n  display: block;\n  margin-bottom: 0.5rem;\n}\n\n.account-deletion-confirmation label strong,\n.account-deletion-phrase {\n  font-family: var(--font-mono);\n}\n\n.account-deletion-handoffs {\n  margin: 0 0 1.5rem;\n}\n\n.account-deletion-handoffs h4,\n.account-deletion-handoffs-intro {\n  margin: 0;\n}\n\n.account-deletion-handoffs h4 {\n  font-family: var(--font-display);\n}\n\n.account-deletion-handoffs-intro,\n.account-deletion-candidate-status,\n.account-deletion-handoff-heading p,\n.account-deletion-handoff-ownership {\n  color: var(--secondary-text-color);\n  line-height: 1.5;\n}\n\n.account-deletion-handoffs-intro {\n  margin-top: 0.35rem;\n}\n\n.account-deletion-handoff-ledger {\n  margin-top: 1rem;\n  border-top: 1px solid var(--border-color);\n}\n\n.account-deletion-handoff-row {\n  padding: 1rem 0;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.account-deletion-handoff-heading {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.account-deletion-handoff-heading h5,\n.account-deletion-handoff-heading p,\n.account-deletion-handoff-ownership {\n  margin: 0;\n}\n\n.account-deletion-handoff-heading h5 {\n  font-family: var(--font-display);\n  font-size: 1rem;\n}\n\n.account-deletion-handoff-heading p {\n  font-family: var(--font-mono);\n  font-size: 0.78rem;\n}\n\n.account-deletion-handoff-ownership {\n  margin-top: 0.25rem;\n  font-size: 0.9rem;\n}\n\n.account-deletion-handoff-row label {\n  margin: 0.8rem 0 0.35rem;\n  font-weight: 600;\n}\n\n.account-deletion-successor-select {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 0.72rem 0.8rem;\n  border: 1px solid var(--input-border);\n  border-radius: var(--radius-sm);\n  background: var(--background-color);\n  color: var(--text-color);\n  font: inherit;\n}\n\n.account-deletion-candidate-status {\n  margin: 0 0 1.5rem;\n}\n\n.account-deletion-candidate-error,\n.account-deletion-candidate-blocker {\n  color: var(--danger-text);\n  line-height: 1.5;\n}\n\n.account-deletion-candidate-error {\n  margin: 0 0 1.5rem;\n}\n\n.account-deletion-candidate-blocker {\n  margin: 0.5rem 0 0;\n  font-size: 0.9rem;\n}\n\n.account-deletion-phrase-control {\n  max-width: 21rem;\n}\n\n.account-deletion-phrase {\n  box-sizing: border-box;\n  width: 100%;\n  margin-bottom: 0.75rem;\n  padding: 0.72rem 0.8rem;\n  border: 1px solid var(--input-border);\n  border-radius: var(--radius-sm);\n  background: var(--background-color);\n  color: var(--text-color);\n  letter-spacing: 0.04em;\n}\n\n.account-deletion-submit-button:not(:disabled) {\n  border-color: var(--danger-button-bg);\n  background: var(--danger-button-bg);\n  color: var(--danger-button-text);\n}\n\n.account-deletion-submit-button:not(:disabled):hover {\n  border-color: var(--danger-button-hover);\n  background: var(--danger-button-hover);\n}\n\n.account-deletion-request-error,\n.account-deletion-status-error {\n  color: var(--danger-text);\n  line-height: 1.5;\n}\n\n.account-deletion-receipt {\n  margin-top: clamp(2rem, 9vh, 5rem);\n  padding: 1.5rem;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius);\n  background: var(--surface-raised);\n}\n\n.account-deletion-eyebrow {\n  margin: 0 0 0.5rem;\n  color: var(--secondary-text-color);\n  font-family: var(--font-mono);\n  font-size: 0.73rem;\n  letter-spacing: 0.09em;\n  text-transform: uppercase;\n}\n\n.account-deletion-receipt h2 {\n  margin: 0;\n  font-family: var(--font-display);\n}\n\n.account-deletion-receipt-copy,\n.account-deletion-receipt-note {\n  color: var(--secondary-text-color);\n  line-height: 1.55;\n}\n\n.account-deletion-progress {\n  margin: 1.75rem 0;\n  padding: 1rem 0;\n  border-top: 1px solid var(--border-color);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.account-deletion-progress-track {\n  height: 0.5rem;\n  overflow: hidden;\n  border-radius: 999px;\n  background: var(--surface-2);\n}\n\n.account-deletion-progress-track span {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: var(--link-color);\n}\n\n.account-deletion-progress--completed .account-deletion-progress-track span {\n  background: var(--success-text);\n}\n\n.account-deletion-progress p {\n  margin: 0.75rem 0 0;\n  color: var(--secondary-text-color);\n}\n\n.account-deletion-progress strong {\n  color: var(--text-color);\n  font-family: var(--font-mono);\n  font-size: 1.4rem;\n}\n\n@media (max-width: 560px) {\n  .account-deletion-summary {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 0.85rem;\n  }\n\n  .account-deletion-confirmation {\n    padding-left: 0.75rem;\n  }\n\n  .account-deletion-confirmation form {\n    max-width: none;\n  }\n\n  .account-deletion-handoff-heading {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 0.15rem;\n  }\n\n  .account-deletion-receipt {\n    padding: 1.1rem;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .account-deletion-review-button,\n  .account-deletion-submit-button,\n  .account-deletion-progress-track span {\n    transition: none;\n  }\n}\n\n/* Button styles */\n.lightButton {\n  background-color: var(--button-light-bg);\n  color: var(--text-color);\n  padding: 0.5rem 1rem;\n  font-size: 1rem;\n  border: 1px solid var(--button-light-border);\n  border-radius: 999px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.lightButton:not(:disabled):hover {\n  background-color: var(--accent-tint);\n  border-color: var(--link-color);\n  color: var(--accent-tint-text) !important;\n}\n\n/* Only the hover was guarded against :disabled, so a disabled light button\n   kept full contrast and a pointer cursor and read as perfectly clickable.\n   Opacity follows `.delete-button:disabled`, the existing convention. */\n.lightButton:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n/* Secondary action: quiet outline pill (referenced across modals; was\n   previously undefined and fell back to the primary button style) */\n.secondaryButton {\n  background-color: transparent;\n  color: var(--text-color);\n  border: 1px solid var(--button-light-border);\n  border-radius: 999px;\n}\n\n.secondaryButton:not(:disabled):hover {\n  background-color: var(--accent-tint);\n  border-color: var(--link-color);\n  color: var(--accent-tint-text);\n}\n\n/* Description text style */\n.descriptionText {\n  color: var(--secondary-text-color);\n  margin-bottom: 1rem;\n  font-size: 1rem;\n  line-height: 1.5;\n}\n\n/* Breadcrumb styles */\n.breadcrumb {\n  margin-bottom: 1.5rem;\n  padding: 0.5rem 0;\n}\n\n.breadcrumb ol {\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.breadcrumb li {\n  display: flex;\n  align-items: center;\n  margin: 0;\n  font-size: 0.78rem;\n  letter-spacing: 0.02em;\n  color: var(--secondary-text-color);\n}\n\n.breadcrumb li a {\n  color: var(--secondary-text-color);\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\n.breadcrumb li a:hover {\n  color: var(--link-color);\n  text-decoration: none;\n}\n\n.breadcrumb li.active {\n  color: var(--secondary-text-color);\n}\n\n.breadcrumb .separator {\n  margin: 0 0.5rem;\n  color: var(--border-strong);\n}\n\n/* Every modal surface (shared Modal plus the bare overlays that bypass it):\n   `manipulation` kills double-tap zoom while keeping normal touch scrolling,\n   and `contain` stops a scroll that hits the modal's edge from chaining into\n   the page behind it. Pinch-zoom is cancelled in JS while a body scroll lock\n   is held — see useBodyScrollLock. */\n.delete-modal-overlay,\n.knowledge-search-modal-overlay,\n.tools-modal-overlay,\n.wiki-create-overlay,\n.audio-settings-overlay,\n.email-overlay,\n.interaction-modal-backdrop,\n.chat-dock-backdrop,\n.knowledge-graph-container.fullscreen {\n  touch-action: manipulation;\n  overscroll-behavior: contain;\n}\n\n/* Delete Modal Styles */\n.delete-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(4px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 3000;\n}\n\n.delete-modal-container {\n  --modal-pad: 20px;\n  background-color: rgba(var(--modal-bg-rgb, 255, 255, 255), 0.92);\n  color: var(--text-color);\n  padding: var(--modal-pad);\n  border-radius: var(--radius);\n  max-width: 400px;\n  width: 100%;\n  box-shadow:\n    var(--card-shadow),\n    0 0 15px rgba(0, 0, 0, 0.2);\n  border: 1px solid rgba(var(--border-color-rgb, 209, 213, 219), 0.5);\n  backdrop-filter: blur(10px);\n}\n\n/* Initial programmatic focus belongs to the dialog surface. The surface is\n   already visually unmistakable; suppress the global focus ring here so it\n   does not appear as a stray outline around the header's close control. */\n.delete-modal-container:focus {\n  outline: none;\n}\n\n/* Content-heavy modals (e.g. the project card detail) become an app surface\n   on phones: full-screen, no floating card, matching the mobile chat dock.\n   !important overrides the inline maxWidth/maxHeight the Modal sets. */\n@media (max-width: 768px) {\n  .delete-modal-container.modal-fullscreen-mobile {\n    box-sizing: border-box;\n    width: 100vw;\n    width: 100dvw;\n    height: 100vh;\n    height: 100dvh;\n    max-width: none !important;\n    max-height: 100dvh !important;\n    border: 0;\n    border-radius: 0;\n    box-shadow: none;\n    padding-top: calc(var(--modal-pad) + env(safe-area-inset-top));\n    padding-bottom: calc(var(--modal-pad) + env(safe-area-inset-bottom));\n    /* Column layout: the header holds its height, the body fills the rest\n       and scrolls inside itself. Without this the modal is 100dvh but the\n       content flows at its natural height, leaving empty space (and a\n       mid-screen composer) below a short card. */\n    display: flex;\n    flex-direction: column;\n    overflow: hidden !important;\n  }\n\n  /* Header (title + close row) keeps its natural height */\n  .delete-modal-container.modal-fullscreen-mobile > :first-child {\n    flex: 0 0 auto;\n  }\n\n  /* The card body grows to fill and scrolls internally. Its desktop\n     max-height (72vh) would otherwise cap it short of the screen, leaving\n     empty space and a mid-screen composer. */\n  .delete-modal-container.modal-fullscreen-mobile > .card-detail {\n    flex: 1 1 auto;\n    min-height: 0;\n    max-height: none;\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n  }\n\n  /* Pin the composer to the bottom of the screen when the card is short;\n     it still scrolls with (and sticks over) a long card's content */\n  .modal-fullscreen-mobile .card-detail-footer {\n    margin-top: auto;\n  }\n}\n\n.delete-modal-actions {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.delete-button {\n  background-color: var(--button-light-bg);\n  color: var(--danger-text);\n  border: 1px solid var(--danger-text);\n  transition: all 0.2s ease;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.delete-button:not(:disabled):hover {\n  background-color: var(--danger-text);\n  color: var(--background-color);\n  box-shadow: none;\n}\n\n.delete-button:active {\n  opacity: 0.85;\n}\n\n.delete-button:disabled {\n  opacity: 0.7;\n}\n\n.member-removal-handoff {\n  display: grid;\n  gap: 0.75rem;\n}\n\n.member-removal-handoff p {\n  margin: 0;\n  color: var(--text-color);\n}\n\n.member-removal-handoff .error-message {\n  color: var(--danger-text);\n}\n\n.member-removal-handoff label {\n  display: grid;\n  gap: 0.4rem;\n  color: var(--text-color);\n  font-weight: 600;\n}\n\n.member-removal-handoff select {\n  width: 100%;\n  color: var(--text-color);\n  background: var(--input-bg);\n  border: 1px solid var(--input-border);\n  border-radius: var(--radius);\n  padding: 0.6rem 0.7rem;\n}\n\n.member-removal-handoff-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  margin-top: 0.5rem;\n}\n\n/* Add and Edit Icon Button Styles */\n.icon-button {\n  display: inline-flex;\n  align-items: center;\n  background: none;\n  border: none;\n  color: var(--link-color);\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 999px;\n  transition: all 0.2s ease;\n}\n\n.icon-button:not(:disabled):hover {\n  background-color: var(--accent-tint);\n  /* Pair the accent-tint hover background with its intended text color so the\n     label stays high-contrast in light and dark mode. */\n  color: var(--accent-tint-text);\n}\n\n.icon-button:active {\n  background-color: var(--card-hover);\n}\n\n.icon-button svg {\n  margin-right: 0.25rem;\n}\n\n/* Info message with warning icon */\n.info-message {\n  font-size: 0.85rem;\n  padding: 8px 12px;\n  margin-top: 8px;\n  border: 1px solid var(--warning-border);\n  border-radius: var(--radius-sm);\n  background-color: var(--warning-bg);\n  color: var(--text-color);\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.info-message::before {\n  content: '⚠️';\n  font-size: 1rem;\n  display: inline-block;\n}\n\n/* Mermaid diagrams (```mermaid fences hydrated client-side) */\n.mermaid-diagram {\n  margin: 0.75em 0;\n  overflow-x: auto;\n  text-align: center;\n}\n\n.mermaid-diagram svg {\n  max-width: 100%;\n  height: auto;\n}\n\n.mermaid-error {\n  margin: 0.75em 0;\n  padding: 8px 10px;\n  border: 1px solid var(--error-color, #d24c4c);\n  border-radius: var(--radius-sm, 6px);\n  font-size: 0.85em;\n}\n\n.mermaid-error-message {\n  color: var(--error-color, #d24c4c);\n  margin-bottom: 6px;\n}\n\n.mermaid-error pre {\n  margin: 0;\n  overflow-x: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
